import React, { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "./firebaseConfig";

const Checkout = ({ cart, setCart }) => {
  const [orderType, setOrderType] = useState("inhouse");
  const [customerInfo, setCustomerInfo] = useState({ name: "", phone: "", address: "" });
  const [loading, setLoading] = useState(false);

  const handleOrder = async () => {
    if (orderType === "delivery" && (!customerInfo.name || !customerInfo.phone || !customerInfo.address)) {
      alert("Please fill in all delivery details.");
      return;
    }

    setLoading(true);
    try {
      const orderData = {
        items: cart,
        total: cart.reduce((total, item) => total + item.price * item.quantity, 0).toFixed(2),
        orderType,
        date: new Date().toISOString(),
        customerInfo: orderType === "delivery" ? customerInfo : null,
      };

      await addDoc(collection(db, "orders"), orderData);
      alert("Order placed successfully!");
      setCart([]);
      
      // ✅ Redirect back to menu after successful order
      window.location.href = "/";
    } catch (error) {
      console.error("Error placing order: ", error);
      alert("Failed to place order.");
    }
    setLoading(false);
  };

  return (
    <div className="bg-black text-gold p-6 min-h-screen">
      <h1 className="text-3xl font-bold mb-4 text-center">Checkout</h1>
      <hr/>
      <p className="text-lg text-gray-400">
        Total:
           {/* ${cart.reduce((total, item) => total + item.price * item.quantity, 0).toFixed(2)} */}
	 {(cart.reduce((total, item) => total + item.price * item.quantity, 0)*89500)%5000>2500 ? ((cart.reduce((total, item) => total + item.price * item.quantity, 0)*89500)-(cart.reduce((total, item) => total + item.price * item.quantity, 0)*89500)%5000+5000):((cart.reduce((total, item) => total + item.price * item.quantity, 0)*89500)-(cart.reduce((total, item) => total + item.price * item.quantity, 0)*89500)%5000)}LBP

      </p>
      
      <div className="mt-4">
        <label className="text-xl">Order Type:</label>
        <select value={orderType} onChange={(e) => setOrderType(e.target.value)} className="lov-dropdown">
          <option value="inhouse">In House</option>
          <option value="delivery">Delivery</option>
        </select>
      </div>

      {orderType === "delivery" && (
        <div className="mt-4">
          <input type="text" placeholder="Name" value={customerInfo.name} onChange={(e) => setCustomerInfo({ ...customerInfo, name: e.target.value })} className="input-text" />
          <input type="text" placeholder="Phone" value={customerInfo.phone} onChange={(e) => setCustomerInfo({ ...customerInfo, phone: e.target.value })} className="input-text" />
          <input type="text" placeholder="Address" value={customerInfo.address} onChange={(e) => setCustomerInfo({ ...customerInfo, address: e.target.value })} className="input-text" />
        </div>
      )}
<hr/>
      <button onClick={handleOrder} disabled={loading} className="button">
        {loading ? "Processing..." : "Confirm Order"}
      </button>

      <button onClick={() => window.location.href = "/"} className="button-red">
        Go Back to Menu
      </button>
    </div>
  );
};

export default Checkout;

